import { type ILog, Log } from '@servicetitan/log-service';
import { inject, injectable, symbolToken } from '@servicetitan/react-ioc';
import { makeObservable, observable } from 'mobx';
import type { IMainApi } from '../../api';
import { ApiModels, MAIN_API_TOKEN } from '../../api';

export const USER_STORE_TOKEN = symbolToken<IUserStore>('USER_STORE_TOKEN');

export interface IUserStore {
    user?: ApiModels.User;
    initUser(): Promise<ApiModels.User | undefined>;
}

@injectable()
export class UserStore implements IUserStore {
    @observable
    user?: ApiModels.User;

    private userPromise?: Promise<ApiModels.User | undefined>;

    constructor(
        @inject(Log) private readonly log: ILog,
        @inject(MAIN_API_TOKEN) private readonly mainApi: IMainApi
    ) {
        makeObservable(this);
    }

    async initUser() {
        if (this.user) {
            return this.user;
        }
        this.userPromise ??= this.loadUser();
        this.user = await this.userPromise;
        return this.user;
    }

    private async loadUser() {
        try {
            const user = await this.mainApi.me();
            return user;
        } catch (error: unknown) {
            if (ApiModels.ApiException.isApiException(error)) {
                const apiException = error as ApiModels.ApiException;
                if (apiException.status === 401) {
                    // Redirect to login page with returnUrl
                    window?.location.replace(
                        '/auth/login?returnUrl=' + encodeURIComponent(window.location.href)
                    );
                    return;
                }
            }
            const message = error instanceof Error ? error.message : 'Unknown error';
            this.log.error({
                category: 'ISH FE',
                code: 'LoadUserFailed',
                message,
                error,
            });
        }
    }
}
